import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Dialog from '../../dialogs/Dialog';
import Button from '../../buttons/Button';
import DropDownList from '../../forms/DropDownList';
import withMeta from '../../utils/withMeta';
import LoadingPanel from '../../LoadingPanel';
import "./Prava.scss";

const AKT_DATA = [
  { id: 0, name: 'Doplniť práva' },
  { id: 1, name: 'Zaktualizovať práva' },
  { id: 2, name: 'Obnoviť práva' }
];

const UzPravaPrj = ({ selected, primaryField, showMsg, meta, db }) => {
  const [state, setState] = useState({
    isOpen: false,
    akt: AKT_DATA[0],
    isLoading: false
  });

  const handleOpen = () => {
    setState((prevState) => ({
      ...prevState,
      isOpen: true
    }));
  };

  const handleClose = () => {
    setState((prevState) => ({
      ...prevState,
      isOpen: false
    }));
  };

  const handleConfirm = async () => {
    setState((prevState) => ({ ...prevState, isLoading: true }));

    try {
      const data = selected.map(x => ({ id: x[primaryField], iAkt: state.akt.id }));
      await meta.setUzPravaPrj(data, db);
      showMsg('Akcia priradenia práv prebehla úspešne');
    } catch (error) {
      showMsg(error.message, 'error');
    }

    setState((prevState) => ({ ...prevState, isOpen: false, isLoading: false }));
  };

  const handleChange = (name, value) => {
    setState((prevState) => ({ ...prevState, [name]: value }));
  };

  return (
    <>
      <Dialog
        isOpen={state.isOpen}
        onClose={handleClose}
        onConfirm={handleConfirm}
        title='Priradenie práv'
      >
        <div style={{ margin: 10 }}>
          <DropDownList
            name="akt"
            data={AKT_DATA}
            textField="name"
            onChange={handleChange}
            value={state.akt}
          />
          <LoadingPanel isLoading={state.isLoading} />
        </div>
      </Dialog>
      <Button
        onClick={handleOpen}
        title="Priradenie práv"
        icon="user"
        disabled={selected && selected.length === 0}
      />
    </>
  );

}

UzPravaPrj.propTypes = {
  selected: PropTypes.array.isRequired,
  primaryField: PropTypes.string.isRequired,
  showMsg: PropTypes.func.isRequired,
  db: PropTypes.string,
  meta: PropTypes.func
}

export default withMeta(UzPravaPrj);